import React, { Component } from 'react';
import Slider2 from './Slider2';
import { withTranslation } from 'react-i18next';
import Cards from './Cards';
import ClinicMap from './ClinicMap';

class Home extends Component {
  componentDidMount() {
    document.title = 'Inicio - Veterinaria Los Cuartos';
  }

  render() {
    const { t } = this.props;
    return (
      <React.Fragment>
        <Slider2 />
        <div className="container">
          <div className="container titlebg">
            <h1>{t('home.nosDiferencia')}</h1>
          </div>
          <p>{t('home.nosDiferenciaSub')}</p>
        </div>
        <Cards />
        <ClinicMap />
      </React.Fragment>
    );
  }
}

export default withTranslation('global')(Home);
